function debounce(func, wait = 250) {
	let timeout
	return function(...args) {
		const context = this
		clearTimeout(timeout)
		timeout = setTimeout(() => func.apply(context, args), wait)
	}
}

$(function() {
	console.log('whaaat?');
	$('body').on('click', '.m-cart-toggle-coupons', function () {
		var $coupons = $('.m-cart-coupons');
		console.log('toggle', $coupons.is(':visible'));
		if (!$coupons.is(':visible')) {
			$coupons.slideDown();
		} else {
			$coupons.slideUp();
		}
	});

	$('body').on('click', '.basketSignModalOpen', function(e) {
		e.preventDefault();
		console.log('click open');
		$('#basketSignModal').modal('show');
	});

	$('body').on('change', '#frm-basketContactForm input[name=email]', debounce(
		function(e) {
			const $this = $(this);
			const $form = $this.closest('form');
			checkEmail($this, () => trySubmit($form));
		})
	);

	$('body').on('change', '#frm-basketContactForm input[name!=email]', debounce(
		function() {
			trySubmit($(this).closest('form'));
		})
	);

	function checkEmail($input, callback) {
		const val = $input.val();
		if (val === '') return;

		$.ajax(`/basket/?do=checkEmail&email=${val}`, { success: function(res) {
			$input.parent().find('.email-message').remove();
			if (res.exists === '1') {
				const $msg = $('<div>').addClass('email-message invalid-feedback-live').html('Email already exists. <a class="basketSignModalOpen" href="#">Sign In</a> - <a href="/account-reset/">Forgot Password</a>');
				$input.parent().append($msg)
			}
			if (callback) callback();
		}});
	}
	const $basketContactFormEmail = $('#frm-basketContactForm-email');
	if ($basketContactFormEmail.length) {
		checkEmail($basketContactFormEmail);
	}

	function trySubmit($form) {
		const $checkoutButton = $('.checkout-button');

		$checkoutButton.removeClass('enabled').addClass('disabled');
		$form.trigger('validate');

		let data = {};
		for (const item of $form.serializeArray()) data[item.name] = item.value;

		// this pretty much reimplements nette's ajax/snippet update
		// haven't figured a better way to both use frontend form validation and submit the data to server even if invalid
		$.ajax('/basket/', {
			method: 'POST',
			data,
			success: function(data) {
				for (const [snippet, html] of Object.entries(data.snippets) || []) {
					$(`#${snippet}`).html(html);
				}
			}
		});
	}
});
